module.exports = __webpack_public_path__ + "img/barrier_3.0cf289d0.png";